module.exports = __webpack_public_path__ + "static/dan-nguyen.aedc2b03.webp";